export enum EntityTypes {
    Conversation = "Conversation",
    Contact = "Contact",
    MessageTemplate = "MessageTemplate",
    Widget = "WidgetType",
    Topic = "TopicType",
}